import {
  CheckCircle2Icon,
  CloudIcon,
  CompassIcon,
  DatabaseIcon,
  GaugeIcon,
  KeyRoundIcon,
  LayersIcon,
  ListChecksIcon,
  SearchIcon,
  ShieldCheckIcon,
  UsersRoundIcon,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  /** Required scope for the link to fully resolve. */
  scope?: string;
  /** Use to mark a link as a known stub page (rendered with a "WIP" badge). */
  wip?: boolean;
}

export interface NavGroup {
  label: string;
  items: ReadonlyArray<NavItem>;
}

/**
 * Sidebar navigation, grouped per the design review (Pass 1A).
 * Mirrors dexhub's `layouts/nav/nav-items.ts` shape so the migration to the
 * real dexhub `dexUI` package later is mechanical.
 */
export const NAV_GROUPS: ReadonlyArray<NavGroup> = [
  {
    label: 'My data',
    items: [
      { label: 'Dashboard', href: '/data', icon: GaugeIcon },
      { label: 'Trajectories', href: '/data/trajectories', icon: LayersIcon, wip: true },
      { label: 'Tokens', href: '/data/tokens', icon: KeyRoundIcon, wip: true },
    ],
  },
  {
    label: 'Admin',
    items: [
      { label: 'Throughput', href: '/data/admin/throughput', icon: CloudIcon, scope: 'data:admin', wip: true },
      { label: 'Operators', href: '/data/admin/operators', icon: UsersRoundIcon, scope: 'data:admin' },
      { label: 'Integrity', href: '/data/admin/integrity', icon: ShieldCheckIcon, scope: 'data:admin', wip: true },
      { label: 'Cold storage', href: '/data/admin/cold-storage', icon: DatabaseIcon, scope: 'data:admin', wip: true },
    ],
  },
  {
    label: 'Tools',
    items: [
      { label: 'ML Search', href: '/data/search', icon: SearchIcon, wip: true },
      { label: 'Annotation queue', href: '/data/annotation', icon: ListChecksIcon, scope: 'data:annotate', wip: true },
    ],
  },
];

// Re-exported icons that the rest of the app may want to grab without
// pulling lucide-react directly.
export { CheckCircle2Icon, CompassIcon };
